import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/erjiye',
    name: '二级页',
    component: () => import('../views/二级页.vue')

  },{
    path: '/newDetail',
    name: '新闻详情',
    component: () => import('../views/新闻详情.vue')

  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
